import gql from "graphql-tag";

export const createKnowledgeBaseSectionMutation = gql`
  mutation createKnowledgeBaseSection($name: String!, $visibleForDealers: Boolean) {
    createKnowledgeBaseSection(name: $name, visibleForDealers: $visibleForDealers) {
      id
    }
  }
`;
